import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";

import { GridItem } from "../../AddEditDispute.styled";

const Header = (props) => {
  const { t, title, borderRadius, align } = props;

  return (
    <GridItem
      fontSize="16px"
      fontWeight="700"
      borderRight="1px solid #fff"
      color="#fff"
      backgroundColor="#008395"
      padding="5px 10px"
      textAlign={align}
      gap="0rem"
      leftRadius={borderRadius === "left" ? "5px" : "0px"}
      rightRadius={borderRadius === "right" ? "5px" : "0px"}
    >
      {t(title)}
    </GridItem>
  );
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Header);
